module.exports = __webpack_public_path__ + "img/logo.e093bc23.svg";